var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('v-container',{staticClass:"pa-0 mt-0 chat-drawer-container fluid"},[(_vm.showSaksi)?[_c('index-saksi')]:[_c('index-general')]],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }